import Tray from '@components/containers/tray';
import { COMMON } from '@constants';
import { HStack, VStack } from '@lib/uikit';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { ShareTrayProps } from '../types';
import { CopyToClipboardButton } from './CopyToClipboardButton';
import { ShareButton } from './ShareButton';
import { withURLValidation } from '../hocs/withURLValidation';
import { getNetworkName } from '../utils/network';

export const ShareTray: FC<ShareTrayProps> = withURLValidation(
    ({
        url,
        networks,
        withCopyToClipboard,
        title,
        description,
        isOpen,
        onClose,
        onButtonClick,
    }) => {
        const { t } = useTranslation(COMMON);

        return (
            <Tray
                title={title}
                description={description}
                isOpen={isOpen}
                onClose={onClose}
            >
                <VStack align='center'>
                    <HStack spacing='sm'>
                        {networks.map((network, index) => (
                            <ShareButton
                                key={index}
                                ariaLabel={`Share on ${getNetworkName(
                                    network
                                )}`}
                                url={url}
                                network={network}
                                onClick={onButtonClick}
                            />
                        ))}
                    </HStack>
                    {withCopyToClipboard && (
                        <CopyToClipboardButton
                            label={t('copy_link')}
                            textToCopy={url}
                        />
                    )}
                </VStack>
            </Tray>
        );
    }
);
